import { useParams } from 'react-router-dom';
import { ErrorWidget } from '@/widgets/ErrorWidget';
import { useGetStaffByIdQuery } from '@/entities/Staff';
import { SectionLoader } from '@/shared/ui/Loader';
import { StaffCourses } from '../StaffCourses';
import { AboutStaff } from '../AboutStaff';
import { StaffProfile } from '../StaffProfile';

export const AcademicStaffView = () => {
  const { staffId } = useParams();

  const { data, isLoading } = useGetStaffByIdQuery(staffId ?? '', { skip: !staffId });

  if (isLoading) {
    return <SectionLoader />;
  }

  if (!data) {
    return <ErrorWidget error="Staff not found" />;
  }

  const fullName = `${data.firstName} ${data.lastName}`.trim() || data.username;
  const courses = [...data.courses, ...data.courses, ...data.courses]
  return (
    <section className="flex flex-col gap-y-6">
      <StaffProfile data={data} />
      <AboutStaff name={fullName} about={data.about} />
      {data.courses.length > 0 ? <StaffCourses courses={courses} /> : null}
    </section>
  );
};
